import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  UpdatePlanTypedata,
  UpdateSellingPricedata,
} from "../../../Services/Admin/Addmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { getAllClient } from "../../../Services/Superadmin/Superadmin";

const PlanSubscription = () => {
  const TokenData = getUserFromToken();

  const [plans, setPlans] = useState({
    Basic_plan: "",
    Standard_plan: "",
    Premium_plan: "",
  });

  const [optionSellingLimitPrice, setOptionSellingLimitPrice] = useState("");

  useEffect(() => {
    getAllClientData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllClientData = async () => {
    try {
      const data = { userid: TokenData?.user_id };
      const response = await getAllClient(data);

      if (response.status) {
        const clientData = response.data;
        setPlans({
          Basic_plan: clientData.Basic_plan || "",
          Standard_plan: clientData.Standard_plan || "",
          Premium_plan: clientData.Premium_plan || "",
        });
        setOptionSellingLimitPrice(
          clientData.option_selling_limit_price || ""
        );
      }
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlans((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    try {
      const data = {
        adminId: TokenData?.user_id,
        Basic_plan: plans.Basic_plan,
        Standard_plan: plans.Standard_plan,
        Premium_plan: plans.Premium_plan,
      };

      const response = await UpdatePlanTypedata(data);

      if (response?.status) {
        Swal.fire({
          icon: "success",
          title: "Plan Updated",
          text: "The plans have been updated successfully.",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "There was an error updating the plans. Please try again.",
      });
    }
  };

  const handleUpdateSellingPrice = async () => {
    try {
      const data = {
        adminId: TokenData?.user_id,
        option_selling_limit_price: optionSellingLimitPrice,
      };

      const response = await UpdateSellingPricedata(data);
      if (response?.status) {
        Swal.fire({
          icon: "success",
          title: "Price Updated",
          text: "The option selling limit price has been updated successfully.",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "There was an error updating the price. Please try again.",
      });
    }
  };

  const getPlanDescription = (price) => {
    const p = Number(price);

    if (p <= 499) return "Basic Plan Selected (under ₹500)";
    if (p >= 500 && p <= 999) return "Standard Plan Selected (₹500 - ₹999)";
    if (p >= 1000) return "Premium Plan Selected (₹1000 and above)";

    return "";
  };


  return (
    <div
      className="container-fluid" >
      <div className=" card transaction-table custom-bg">
        <div className="row justify-content-center">
          <div className="col-xl-12 col-lg-12">
            <div className="card shadow-sm border-0 rounded-4 mb-4">
              {/* Header */}
              <div className="card-header  border-0 rounded-top-4 px-4 pt-3 ">
                <div>
                  <h4 className="mb-0">Plan & Subscription Settings</h4>
                  <p className="text-muted small mb-0">
                    Configure subscription plan prices and option selling limits for
                    your users.
                  </p>
                </div>
              </div>
              <hr className="mt-0 mb-0" />

              <div className="card-body px-4 pt-4 pb-4">
                {/* Plans Section */}
                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Subscription Plans</h5>
                    <span className="text-muted small">
                      Set the price for each plan tier.
                    </span>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="border rounded-3 p-3 h-100">
                        <h6 className="mb-2">Basic Plan</h6>
                        <p className="text-muted small mb-2">
                          Entry-level access for new users.
                        </p>
                        <div className="mb-2">
                          <label className="form-label small mb-1">
                            Price (in currency)
                          </label>
                          <input
                            type="number"
                            min="0"
                            className="form-control"
                            name="Basic_plan"
                            value={plans.Basic_plan}
                            onChange={handleChange}
                            placeholder="Enter Basic Plan Price"
                          />
                          <small className="text-primary">
                            {getPlanDescription(plans.Basic_plan)}
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="border rounded-3 p-3 h-100">
                        <h6 className="mb-2">Standard Plan</h6>
                        <p className="text-muted small mb-2">
                          Recommended plan for most traders.
                        </p>
                        <div className="mb-2">
                          <label className="form-label small mb-1">
                            Price (in currency)
                          </label>
                          <input
                            type="number"
                            min="0"
                            className="form-control"
                            name="Standard_plan"
                            value={plans.Standard_plan}
                            onChange={handleChange}
                            placeholder="Enter Standard Plan Price"
                          />
                          <small className="text-primary">
                            {getPlanDescription(plans.Standard_plan)}
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="border rounded-3 p-3 h-100">
                        <h6 className="mb-2">Premium Plan</h6>
                        <p className="text-muted small mb-2">
                          Full access for advanced users.
                        </p>
                        <div className="mb-2">
                          <label className="form-label small mb-1">
                            Price (in currency)
                          </label>
                          <input
                            type="number"
                            min="0"
                            className="form-control"
                            name="Premium_plan"
                            value={plans.Premium_plan}
                            onChange={handleChange}
                            placeholder="Enter Premium Plan Price"
                          />
                          <small className="text-primary">
                            {getPlanDescription(plans.Premium_plan)}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 text-end">
                    <button
                      className="btn btn-primary px-4"
                      type="button"
                      onClick={handleUpdate}
                    >
                      Update Plans
                    </button>
                  </div>
                </div>

                <hr className="my-4" />

                {/* Option Selling Limit Section */}
                <div>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Option Selling Limit</h5>
                    <span className="text-muted small">
                      Control the maximum allowed price for option selling.
                    </span>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">
                        Option Selling Limit Price
                      </label>
                      <input
                        type="number"
                        min="0"
                        className="form-control"
                        value={optionSellingLimitPrice}
                        onChange={(e) =>
                          setOptionSellingLimitPrice(e.target.value)
                        }
                        placeholder="Enter Option Selling Limit Price"
                      />
                      <small className="text-muted">
                        This value will be used as the upper limit for option
                        selling actions.
                      </small>
                    </div>
                  </div>

                  <div className="mt-3 text-end">
                    <button
                      className="btn btn-outline-primary px-4"
                      type="button"
                      onClick={handleUpdateSellingPrice}
                    >
                      Update Price
                    </button>
                  </div>
                </div>
              </div>

              {/* Optional footer note */}
              {/* <div className="card-footer bg-white border-0 text-end px-4 pb-3">
              <small className="text-muted">
                Changes apply immediately for new users and on next billing
                cycle for existing users.
              </small>
            </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanSubscription;
